import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, CheckCircle2Icon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Field, inputClass } from '../../components/ui/Field';
import { razlogi } from '../../components/member/AbsenceModal';
import { eventTitle, eventTypeClass, eventTypeShort, formatDate } from '../../utils/labels';
export function MemberLongAbsence() {
  const navigate = useNavigate();
  const {
    upcoming,
    visibleEvents,
    currentMember,
    addAbsence,
    setRsvp,
    pushToast,
    absences
  } = useApp();
  const me = currentMember!;
  const [od, setOd] = useState('2026-11-27');
  const [doDatum, setDoDatum] = useState('2026-12-11');
  const [razlog, setRazlog] = useState('Odsotnost iz kraja');
  const [opomba, setOpomba] = useState('');
  const [poslano, setPoslano] = useState(false);
  const zadeti = useMemo(() => visibleEvents(me.id).filter(e => upcoming.some(u => u.id === e.id) && e.datum >= od && e.datum <= doDatum), [visibleEvents, upcoming, me.id, od, doDatum]);
  const mojeOdsotnosti = absences.filter(a => a.memberId === me.id);
  function poslji() {
    addAbsence({
      memberId: me.id,
      od,
      do: doDatum,
      razlog,
      opomba: opomba || undefined
    });
    zadeti.forEach(e => setRsvp(e.id, {
      status: 'ne_morem',
      razlog,
      opomba: 'Daljša odsotnost'
    }));
    setPoslano(true);
    pushToast('Daljša odsotnost je bila poslana vodstvu.');
  }
  if (poslano) {
    return <div className="mx-auto max-w-2xl" data-id="element-1657" data-mp="ke4pu2rhudwt">
        <Card className="p-8 text-center" data-id="element-1658" data-mp="p65vh5u5p6dv">
          <CheckCircle2Icon className="mx-auto h-12 w-12 text-green-500" strokeWidth={1.5} data-id="element-1659" data-mp="p77im8og5jby" />
          <h1 className="mt-4 text-xl font-semibold text-ink" data-id="element-1660" data-mp="3nvmu608252sh">Odsotnost je zabeležena</h1>
          <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-ink-muted" data-id="element-1661" data-mp="3suha8uen4d8w">
            Vodstvo je obveščeno o vaši odsotnosti od {formatDate(od)} do {formatDate(doDatum)}. Za{' '}
            {zadeti.length} dogodkov je bila samodejno vpisana odjava.
          </p>
          <div className="mt-6 flex justify-center gap-2" data-id="element-1662" data-mp="3ukcx8wo29y7j">
            <Button variant="secondary" onClick={() => setPoslano(false)} data-id="element-1663" data-mp="3umpf79ttk8kl">
              Prijavi še eno
            </Button>
            <Button onClick={() => navigate('/clan')} data-id="element-1664" data-mp="31vz34s03fm19">Nazaj na domov</Button>
          </div>
        </Card>
      </div>;
  }
  return <div className="mx-auto max-w-2xl space-y-4" data-id="element-1665" data-mp="2wxxgxy7df6lk">
      <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1.5 text-[13px] font-medium text-ink-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-1666" data-mp="2wz8mo3kdmofb">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-1667" data-mp="r3w371govrsj" />
        Nazaj
      </button>

      <div data-id="element-1668" data-mp="r22znv1dhnor">
        <h1 className="text-2xl font-semibold text-ink" data-id="element-1669" data-mp="r5qqunjchy0b">Daljša odsotnost</h1>
        <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1670" data-mp="m4jiondaiwt4">
          Prijavite obdobje, ko vas ne bo na vajah. Vodstvo bo videlo, katerih dogodkov se ne boste udeležili.
        </p>
      </div>

      <Card className="space-y-4 p-5" data-id="element-1671" data-mp="yp00mhvrjypw">
        <div className="grid gap-4 sm:grid-cols-2" data-id="element-1672" data-mp="knnlg8ofg152">
          <Field label="Od" htmlFor="od" data-id="element-1673" data-mp="koyy6xzuoj8b">
            <input id="od" type="date" value={od} onChange={e => setOd(e.target.value)} className={inputClass} data-id="element-1674" data-mp="op95cdzdpfor" />
          </Field>
          <Field label="Do" htmlFor="do" data-id="element-1675" data-mp="1cejwr4uu9xq8">
            <input id="do" type="date" value={doDatum} onChange={e => setDoDatum(e.target.value)} className={inputClass} data-id="element-1676" data-mp="1cflji6l7w8ns" />
          </Field>
        </div>

        <Field label="Razlog" htmlFor="razlog" data-id="element-1677" data-mp="17nv7zxajneus">
          <select id="razlog" value={razlog} onChange={e => setRazlog(e.target.value)} className={inputClass} data-id="element-1678" data-mp="17mk4lyl0g947">
            {razlogi.map(r => <option key={r} data-id="element-1679" data-mp="2045yo02lir1x">{r}</option>)}
          </select>
        </Field>

        <Field label="Opomba (neobvezno)" htmlFor="opomba" data-id="element-1680" data-mp="cg2vpbyh1brd">
          <textarea id="opomba" rows={3} value={opomba} onChange={e => setOpomba(e.target.value)} placeholder="Npr. Vrnem se na vajo 11. decembra." className={inputClass} data-id="element-1681" data-mp="che27jjawxm6" />
        </Field>
      </Card>

      <Card className="p-5" data-id="element-1682" data-mp="3un0rysqayc4b">
        <div className="flex items-center justify-between gap-3" data-id="element-1683" data-mp="3unshbltb3dm5">
          <h2 className="text-base font-semibold text-ink" data-id="element-1684" data-mp="v59awp023l8f">Zadeti dogodki</h2>
          <Badge className="bg-canvas text-ink-muted border-line" data-id="element-1685" data-mp="q77s856jlnxh">{zadeti.length} dogodkov</Badge>
        </div>
        {zadeti.length === 0 ? <p className="mt-3 text-[13px] text-ink-muted" data-id="element-1686" data-mp="leod33s7ikqk">V izbranem obdobju ni vaših dogodkov.</p> : <ul className="mt-3 divide-y divide-line" data-id="element-1687" data-mp="hdcv9kfkr3sx">
            {zadeti.map(e => <li key={e.id} className="flex items-center gap-3 py-2.5" data-id="element-1688" data-mp="1dz6hxu6qnlu5">
                <span className="w-20 shrink-0 text-[13px] text-ink-muted" data-id="element-1689" data-mp="195k3pxkxf9w8">{formatDate(e.datum)}</span>
                <span className="min-w-0 flex-1 truncate text-sm font-medium text-ink" data-id="element-1690" data-mp="2ruo8sbsr04ur">{eventTitle(e)}</span>
                <Badge className={eventTypeClass[e.type]} data-id="element-1691" data-mp="2wsgdk6ehrlgd">{eventTypeShort[e.type]}</Badge>
              </li>)}
          </ul>}
        <p className="mt-4 rounded-lg bg-canvas px-3 py-2.5 text-xs leading-relaxed text-ink-muted" data-id="element-1692" data-mp="35smj963y7h4z">
          Opravičena odsotnost se še vedno šteje kot odsotnost pri izračunu odstotka prisotnosti.
        </p>
        <Button className="mt-4" full onClick={poslji} data-id="element-1693" data-mp="3fq94097xi2wv">
          Potrdi odsotnost
        </Button>
      </Card>

      {mojeOdsotnosti.length > 0 && <Card className="p-5" data-id="element-1694" data-mp="3kjvhu4ptwcu9">
          <h2 className="text-base font-semibold text-ink" data-id="element-1695" data-mp="3oj48v1thhwm4">Prijavljene odsotnosti</h2>
          <ul className="mt-3 divide-y divide-line" data-id="element-1696" data-mp="3tigzlxnh7ntz">
            {mojeOdsotnosti.map(a => <li key={a.id} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-1697" data-mp="2c5r5gg4zksm">
                <span className="text-ink" data-id="element-1698" data-mp="1yfahstvf9x1l">
                  {formatDate(a.od)} – {formatDate(a.do)}
                </span>
                <Badge className="bg-canvas text-ink-muted border-line" data-id="element-1699" data-mp="1tgpozfii2fn6">{a.razlog}</Badge>
              </li>)}
          </ul>
        </Card>}
    </div>;
}